export const SORTABLE_STORE = 'sortable_store';
export const CONVERSATION_STORE = 'conversation_view_restorer';
export const GENERAL_STORE = 'general_store';
export const PENDING_PINS_STORE = 'pending_pin_chats';
export const VIEW_PREFERENCES_STORE = 'view_preference';
